import { render } from "./ObjectOneCCard.vue?vue&type=template&id=558dcb86"
import script from "./ObjectOneCCard.vue?vue&type=script&lang=js"
export * from "./ObjectOneCCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__